import { ReactNode } from 'react';

import { Stack } from '@cast/design-system';

type Props = {
  children: ReactNode;
};

export function TourStepImage(props: Props) {
  return (
    <Stack mx={-24} mb={-20} mt={8}>
      {props.children}
    </Stack>
  );
}
